'use strict';

(function() {
  /**
   * TextesOfficielsController - contrôleur pour la page des textes officiels
   */
  angular
    .module('observatoireApp')
    .controller('TextesOfficielsController', ['$scope', '$state', '$sce', '$timeout', 'TextesOfficielsService', 'FavorisService', 'Auth', function($scope, $state, $sce, $timeout, TextesOfficielsService, FavorisService, Auth) {

      // Favoris
      Auth.identity().then(function(user) {
        $scope.utilisateurConnecte = !!user;
      });

      $scope.isFavoriTexte = function(texte) {
        return FavorisService.isFavori('to_' + texte.id);
      };

      $scope.toggleFavoriTexte = function(texte) {
        if (!$scope.utilisateurConnecte) return;
        var favoriId = 'to_' + texte.id;
        if (FavorisService.isFavori(favoriId)) {
          FavorisService.removeFavori(favoriId);
        } else {
          FavorisService.addFavori({
            id: favoriId,
            itemType: 'texte-officiel',
            titre: texte.title,
            categorie: texte.categoryName || 'Texte officiel',
            fileUrl: texte.fileUrl || null,
            fileType: texte.fileType || null,
            dateAjout: new Date()
          });
        }
      };

  /**
   * Initialisation
   */
  function init() {
    // Initialisation
    $scope.isLoading = true;
    $scope.textesOfficiels = [];
    $scope.filteredTextesOfficiels = [];
    $scope.displayedTextesOfficiels = [];
    $scope.categories = [];
    $scope.selectedCategory = null;
    $scope.searchText = '';
    $scope.currentPage = 1;
    
    // Initialiser l'objet pour les étoiles
    $scope.stars = [1, 2, 3, 4, 5];
    
    // Récupérer le nombre d'éléments par page depuis localStorage ou utiliser la valeur par défaut
    var savedItemsPerPage = localStorage.getItem('textesOfficielsItemsPerPage');
    $scope.itemsPerPage = savedItemsPerPage ? parseInt(savedItemsPerPage) : 9;
    
    // Paramètres de pagination
    $scope.totalItems = 0;
    $scope.totalPages = 1;
    $scope.maxPageButtons = 5;
    
    // Chargement initial
    loadTextesOfficiels();
    loadCategories();
    loadUserRatings();
  }
  
  /**
   * Charge les textes officiels
   */
  function loadTextesOfficiels() {
    $scope.isLoading = true;
    console.log('Début du chargement de tous les textes officiels via l\'API');
    
    TextesOfficielsService.getAllTextesOfficiels()
      .then(function(result) {
        console.log('Données reçues de l\'API pour tous les textes officiels:', result);
        
        // Vérifier si nous avons reçu des données
        if (!result || result.length === 0) {
          console.warn('Aucun texte officiel reçu de l\'API - la base de données est peut-être vide');
        } else {
          // Afficher le premier élément pour comprendre la structure des données
          console.log('Structure du premier texte officiel:', result[0]);
        }
        
        $scope.textesOfficiels = result;
        $scope.filteredTextesOfficiels = angular.copy($scope.textesOfficiels);
        $scope.totalItems = $scope.filteredTextesOfficiels.length;
        applyFilters();
        $scope.isLoading = false;
        $scope.calculateTotalPages();
        $scope.updateDisplayedTextesOfficiels();
      })
      .catch(function(error) {
        console.error('Erreur lors du chargement des textes officiels via l\'API:', error);
        $scope.isLoading = false;
        $scope.hasError = true;
        $scope.errorMessage = 'Erreur lors du chargement des textes officiels: ' + (error.statusText || error.message || 'Erreur inconnue');
      });
  }
  
  /**
   * Charge les catégories de textes officiels
   */
  function loadCategories() {
    TextesOfficielsService.getCategories()
      .then(function(result) {
        $scope.categories = result;
        console.log('Catégories chargées:', result);
      })
      .catch(function(error) {
        console.error('Erreur lors du chargement des catégories', error);
      });
  }
  
  /**
   * Charge les notes précédemment attribuées par l'utilisateur
   */
  function loadUserRatings() {
    var userRatings = TextesOfficielsService.loadUserRatings();
    
    // Si des notes existent, les appliquer aux textes officiels
    if (Object.keys(userRatings).length > 0) {
      $scope.textesOfficiels.forEach(function(texteOfficiel) {
        if (userRatings[texteOfficiel.id]) {
          texteOfficiel.userRating = userRatings[texteOfficiel.id];
        }
      });
    }
  }
  
  /**
   * Filtrer les textes officiels
   */
  function applyFilters() {
    $scope.filteredTextesOfficiels = $scope.textesOfficiels.filter(function(item) {
      // Filtre par catégorie - vérifier plusieurs propriétés possibles pour la catégorie
      var categoryMatch = $scope.selectedCategory === null || 
                         item.categoryCode === $scope.selectedCategory ||
                         item.category === $scope.selectedCategory; // Pour compatibilité avec l'ancien format
      
      // Déboguer pour voir la structure des données
      if ($scope.selectedCategory !== null && !categoryMatch) {
        console.log('Catégorie non correspondante:', item, 'Catégorie recherchée:', $scope.selectedCategory);
      }
      
      // Filtre par texte
      var textMatch = $scope.searchText === '' || 
                     item.title.toLowerCase().indexOf($scope.searchText.toLowerCase()) !== -1 ||
                     item.description.toLowerCase().indexOf($scope.searchText.toLowerCase()) !== -1;
                     
      return categoryMatch && textMatch;
    });
    
    $scope.totalItems = $scope.filteredTextesOfficiels.length;
    $scope.currentPage = 1;
    $scope.calculateTotalPages();
    $scope.updateDisplayedTextesOfficiels();
  }
  
  /**
   * Filtrer par catégorie
   * @param {string} categoryId L'identifiant de la catégorie à filtrer
   */
  $scope.filterByCategory = function(categoryId) {
    $scope.isLoading = true;
    $scope.selectedCategory = categoryId;
    console.log('Filtrage par catégorie:', categoryId);
    
    if (categoryId === null) {
      // Si aucune catégorie n'est sélectionnée, charger tous les textes officiels
      console.log('Chargement de tous les textes officiels');
      loadTextesOfficiels();
    } else {
      // Sinon, charger les textes officiels de la catégorie sélectionnée via l'API
      console.log('Chargement des textes officiels de la catégorie:', categoryId);
      TextesOfficielsService.getTexteOfficielsByCategory(categoryId)
        .then(function(result) {
          console.log('Données reçues de l\'API pour la catégorie', categoryId, ':', result);
          if (result && result.length === 0) {
            console.warn('Aucun texte officiel reçu pour la catégorie', categoryId);
          }
          
          $scope.textesOfficiels = result;
          $scope.filteredTextesOfficiels = angular.copy($scope.textesOfficiels);
          $scope.totalItems = $scope.filteredTextesOfficiels.length;
          $scope.isLoading = false;
          $scope.calculateTotalPages();
          $scope.updateDisplayedTextesOfficiels();
        })
        .catch(function(error) {
          console.error('Erreur lors du chargement des textes officiels par catégorie', categoryId, ':', error);
          $scope.isLoading = false;
          $scope.hasError = true;
          $scope.errorMessage = 'Erreur lors du chargement des textes officiels par catégorie: ' + error.message;
        });
    }
  };
  
  /**
   * Rechercher dans les textes officiels
   */
  $scope.search = function() {
    applyFilters();
  };
  
  /**
   * Réinitialiser les filtres
   */
  $scope.resetFilters = function() {
    $scope.selectedCategory = null;
    $scope.searchText = '';
    applyFilters();
  };
  
  /**
   * Affiche le texte officiel dans le visualiseur
   * @param {Object} texteOfficiel - Le texte officiel à visualiser
   */
  $scope.visualizeTexteOfficiel = function(texteOfficiel) {
    if (!texteOfficiel) return;

    // Définir la publication courante immédiatement (avant l'appel API)
    $scope.currentPublication = texteOfficiel;
    // Capturer la date une seule fois — immunisée contre toute mise à jour API
    $scope.viewerDate = texteOfficiel.date;

    // Sécuriser l'URL pour l'iframe (PDF)
    if (texteOfficiel.fileType === 'PDF') {
      $scope.trustedPdfUrl = $sce.trustAsResourceUrl(texteOfficiel.fileUrl);
    }

    // Ouvrir le modal immédiatement
    var el = document.getElementById('publicationViewerModal');
    if (el) bootstrap.Modal.getOrCreateInstance(el).show();

    // Incrémenter le compteur de vues en arrière-plan
    TextesOfficielsService.incrementViews(texteOfficiel.id)
      .then(function(updatedTexteOfficiel) {
        updateTexteOfficielInLists(updatedTexteOfficiel);
      })
      .catch(function(error) {
        console.error('Erreur lors de l\'incrémentation des vues', error);
      });
  };
  
  /**
   * Ferme le visualiseur de textes officiels
   */
  $scope.closeViewer = function() {
    var el = document.getElementById('publicationViewerModal');
    if (el) { var m = bootstrap.Modal.getInstance(el); if (m) m.hide(); }
  };
  /**
   * Télécharge un texte officiel
   * @param {Object} texteOfficiel - Le texte officiel à télécharger
   */
  $scope.downloadTexteOfficiel = function(texteOfficiel) {
    if (!texteOfficiel) return;
    
    // Mettre à jour les compteurs de téléchargements
    TextesOfficielsService.incrementDownloads(texteOfficiel.id)
      .then(function(updatedTexteOfficiel) {
        updateTexteOfficielInLists(updatedTexteOfficiel);
        
        // Créer un lien temporaire et cliquer dessus pour déclencher le téléchargement
        var link = document.createElement('a');
        link.href = texteOfficiel.fileUrl;
        link.download = texteOfficiel.title + '.' + texteOfficiel.fileType.toLowerCase();
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch(function(error) {
        console.error('Erreur lors de l\'incrémentation des téléchargements', error);
      });
  };
  
  /**
   * Partager un texte officiel
   * @param {Object} texteOfficiel - Le texte officiel à partager
   */
  $scope.shareTexteOfficiel = function(texteOfficiel) {
    // S'assurer que l'URL du PDF existe
    if (!texteOfficiel.fileUrl) {
      alert('Impossible de partager : aucun fichier PDF associé à ce texte officiel.');
      return;
    }
    
    // Implémentation du partage 
    if (navigator.share) {
      navigator.share({
        title: texteOfficiel.title,
        text: texteOfficiel.description,
        url: texteOfficiel.fileUrl // Partager directement l'URL du PDF
      })
      .then(() => {
        console.log('Texte officiel PDF partagé');
        // Incrémenter éventuellement un compteur de partages si nécessaire
      })
      .catch((error) => console.log('Erreur lors du partage', error));
    } else {
      // Fallback pour les navigateurs qui ne supportent pas l'API Web Share
      // Créer un élément textarea temporaire pour copier l'URL du PDF
      var tempTextarea = document.createElement('textarea');
      tempTextarea.value = texteOfficiel.fileUrl;
      document.body.appendChild(tempTextarea);
      tempTextarea.select();
      
      try {
        var successful = document.execCommand('copy');
        if (successful) {
          alert('L\'URL du PDF a été copiée dans votre presse-papiers. Vous pouvez maintenant la partager.');
        } else {
          alert('Impossible de copier l\'URL. Veuillez la copier manuellement : ' + texteOfficiel.fileUrl);
        }
      } catch (err) {
        alert('Impossible de partager automatiquement. URL du PDF : ' + texteOfficiel.fileUrl);
      }
      
      document.body.removeChild(tempTextarea);
    }
  };
  
  /**
   * Met à jour un texte officiel dans toutes les listes
   * @param {Object} updatedTexteOfficiel - Le texte officiel mis à jour
   */
  function updateTexteOfficielInLists(updatedTexteOfficiel) {
    if (!updatedTexteOfficiel) return;

    var patch = {
      views:       parseInt(updatedTexteOfficiel.views)       || 0,
      downloads:   parseInt(updatedTexteOfficiel.downloads)   || 0,
      rating:      parseFloat(updatedTexteOfficiel.rating)    || 0,
      ratingCount: parseInt(updatedTexteOfficiel.ratingCount) || 0,
      userRating:  parseInt(updatedTexteOfficiel.userRating)  || 0
    };

    function applyPatch(list) {
      for (var i = 0; i < list.length; i++) {
        if (list[i].id === updatedTexteOfficiel.id) {
          list[i].views       = patch.views;
          list[i].downloads   = patch.downloads;
          list[i].rating      = patch.rating;
          list[i].ratingCount = patch.ratingCount;
          list[i].userRating  = patch.userRating;
          break;
        }
      }
    }

    applyPatch($scope.textesOfficiels);
    applyPatch($scope.filteredTextesOfficiels);
    applyPatch($scope.displayedTextesOfficiels);

    if ($scope.currentPublication && $scope.currentPublication.id === updatedTexteOfficiel.id) {
      $scope.currentPublication.views       = patch.views;
      $scope.currentPublication.downloads   = patch.downloads;
      $scope.currentPublication.rating      = patch.rating;
      $scope.currentPublication.ratingCount = patch.ratingCount;
      $scope.currentPublication.userRating  = patch.userRating;
    }

    if (!$scope.$$phase) {
      $scope.$apply();
    }
  }
  
  /**
   * Attribue une note à un texte officiel
   * @param {Object} texteOfficiel - Le texte officiel à noter
   * @param {number} rating - La note (1-5)
   */
  $scope.rateTexteOfficiel = function(texteOfficiel, rating) {
    if (!texteOfficiel || !rating) return;
    
    // S'assurer que userRating existe
    texteOfficiel.userRating = texteOfficiel.userRating || 0;
    
    // Si l'utilisateur clique sur la même étoile, réinitialiser
    if (texteOfficiel.userRating === rating) {
      rating = 0;
    }
    
    TextesOfficielsService.rateTexteOfficiel(texteOfficiel.id, rating)
      .then(function(updatedTexteOfficiel) {
        // Mettre à jour le texte officiel dans toutes les listes
        updateTexteOfficielInLists(updatedTexteOfficiel);
      })
      .catch(function(error) {
        console.error('Erreur lors de la notation du texte officiel', error);
      });
  };
  
  /**
   * Vérifie si une étoile doit être remplie ou non
   * @param {Object} texteOfficiel - Le texte officiel à vérifier
   * @param {number} starValue - La valeur de l'étoile (1-5)
   * @returns {boolean} Vrai si l'étoile doit être remplie, faux sinon
   */
  $scope.isStarFilled = function(texteOfficiel, starValue) {
    // Vérifier si texteOfficiel existe
    if (!texteOfficiel) return false;
    // Vérifier si userRating existe
    var userRating = texteOfficiel.userRating || 0;
    return userRating >= starValue;
  };
  
  /**
   * Vérifie si une étoile doit être remplie ou non en mode prévisualisation
   * @param {Object} texteOfficiel - Le texte officiel à vérifier
   * @param {number} starValue - La valeur de l'étoile (1-5)
   * @param {number} hoverValue - La valeur de l'étoile survolée
   * @returns {boolean} Vrai si l'étoile doit être remplie, faux sinon
   */
  $scope.isStarFilledPreview = function(texteOfficiel, starValue, hoverValue) {
    // Vérifier si texteOfficiel existe
    if (!texteOfficiel) return false;
    
    if (!hoverValue) {
      // Vérifier si userRating existe
      var userRating = texteOfficiel.userRating || 0;
      return userRating >= starValue;
    }
    return hoverValue >= starValue;
  };
  
  /**
   * Convertit la note moyenne en pourcentage pour l'affichage des étoiles
   * @param {number} rating - La note moyenne (0-5)
   * @returns {string} La largeur des étoiles remplies en pourcentage
   */
  $scope.getRatingPercentage = function(rating) {
    // S'assurer que rating est un nombre valide
    rating = parseFloat(rating) || 0;
    return (Math.min(Math.max(rating, 0), 5) / 5 * 100) + '%';
  };
  
  /**
   * Calcule le nombre total de pages
   */
  $scope.calculateTotalPages = function() {
    $scope.totalPages = Math.ceil($scope.totalItems / $scope.itemsPerPage) || 1;
  };
  
  /**
   * Navigue vers une page spécifique
   * @param {number} page - Le numéro de page
   */
  $scope.goToPage = function(page) {
    if (page < 1) page = 1;
    if (page > $scope.totalPages) page = $scope.totalPages;
    
    $scope.currentPage = page;
    $scope.updateDisplayedTextesOfficiels();
  };
  
  /**
   * Retourne la plage de pages à afficher dans la pagination
   * @returns {Array} Tableau des numéros de page à afficher
   */
  $scope.getPageRange = function() {
    var startPage = Math.max(1, $scope.currentPage - Math.floor($scope.maxPageButtons / 2));
    var endPage = Math.min($scope.totalPages, startPage + $scope.maxPageButtons - 1);
    
    if (endPage - startPage + 1 < $scope.maxPageButtons) {
      startPage = Math.max(1, endPage - $scope.maxPageButtons + 1);
    }
    
    var pages = [];
    for (var i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    
    return pages;
  };
  
  /**
   * Change le nombre d'éléments par page
   * @param {number} itemsPerPage - Le nouveau nombre d'éléments par page
   */
  $scope.setItemsPerPage = function(itemsPerPage) {
    $scope.itemsPerPage = itemsPerPage;
    localStorage.setItem('textesOfficielsItemsPerPage', itemsPerPage);
    $scope.calculateTotalPages();
    
    // Ajuster la page courante si nécessaire
    if ($scope.currentPage > $scope.totalPages) {
      $scope.currentPage = $scope.totalPages;
    }
    
    $scope.updateDisplayedTextesOfficiels();
  };
  
  /**
   * Met à jour la liste des textes officiels affichés en fonction de la page courante
   */
  $scope.updateDisplayedTextesOfficiels = function() {
    // Forcer la conversion du nombre d'éléments par page en nombre entier
    $scope.itemsPerPage = Number($scope.itemsPerPage);

    // Calculer les indices de début et de fin pour la pagination
    var startIndex = ($scope.currentPage - 1) * $scope.itemsPerPage;
    var endIndex = startIndex + $scope.itemsPerPage;

    // S'assurer que les indices sont valides
    if (startIndex < 0) startIndex = 0;
    if (endIndex > $scope.filteredTextesOfficiels.length) {
      endIndex = $scope.filteredTextesOfficiels.length;
    }

    // Vider le tableau existant et le remplir avec les éléments de la page actuelle
    $scope.displayedTextesOfficiels = [];
    for (var i = startIndex; i < endIndex; i++) {
      $scope.displayedTextesOfficiels.push($scope.filteredTextesOfficiels[i]);
    }

    console.log('Nombre d\'éléments par page: ' + $scope.itemsPerPage);
    console.log('Affichage des éléments ' + startIndex + ' à ' + endIndex + ' sur ' + $scope.totalItems);
    console.log('Nombre d\'éléments affichés: ' + $scope.displayedTextesOfficiels.length);
  };

  // Mise à jour du nombre total de pages lorsque les filtres sont appliqués
  $scope.$watch('filteredTextesOfficiels.length', function(newVal) {
    $scope.totalItems = newVal;
    $scope.calculateTotalPages();
    $scope.updateDisplayedTextesOfficiels();
  });
  
  // Initialiser le contrôleur
  init();
    }]);
})();
